let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b8kSs")).then(() => parcelRequire('avwIL'));